import { render, staticRenderFns } from "./rssComponent.vue?vue&type=template&id=24761102&scoped=true"
import script from "./rssComponent.vue?vue&type=script&lang=js"
export * from "./rssComponent.vue?vue&type=script&lang=js"
import style0 from "./rssComponent.vue?vue&type=style&index=0&id=24761102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24761102",
  null
  
)

export default component.exports